<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/modelo"> Cadastro/Equipamento/Modelos </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <tab-navegacao-equipamento />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col col="6">
            <v-text-field
              label="Descrição *"
              v-model="descricao"
              v-uppercase
              :counter="200"
              :rules="[(v) => !!v || 'O modelo é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col col="6">
            <v-select
              v-model="marcaEquipamentoSelected"
              :items="findMarcasAtivas"
              label="Marca Equipamento *"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              :rules="[(v) => !!v || 'A marca do equipamento é obrigatória']"
              required
            >
            </v-select>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn to="/modelo" color="error" class="mr-4">
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import TabNavegacaoEquipamento from "../../Tabs/TabCadastroEquipamento";
import { enviarModeloAsync } from "../../../services/modeloService";
import { mapState } from "vuex";

export default {
  name: "criarModelo",
  data: () => ({
    overlay: false,
    valid: true,
    descricao: null,
    marcaEquipamentoSelected: null,
  }),
  computed: {
    ...mapState("modelo", ["modelos"]),
    ...mapState("marcaEquipamento", ["marcaEquipamentos"]),
    
    findMarcasAtivas() {
      return this.marcaEquipamentos.filter((m) => {
        return m.ativo === true;
      });
    }

  },
  methods: {
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await enviarModeloAsync(this.descricao, this.marcaEquipamentoSelected.descricao, this.marcaEquipamentoSelected.id);
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Desculpe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$router.push("/modelo");
        }
      }
    },
  },
  components: {
    TabNavegacaoEquipamento,
  },
};
</script>
